module.exports = __webpack_public_path__ + "img/more-disabled.ac56080b.svg";